import React from "react";
import { formatScore } from "../../decision/importColumns.mjs";

// key відповідає полю рядка звіту (mergeReport, ../../decision/importColumns.mjs)
// -- сортування (sortReportRows) читає його напряму як row[key], тому key і
// назва поля мають збігатися дослівно.
const COLUMNS = [
  { key: "id", label: "№" },
  { key: "pib", label: "ПІБ" },
  { key: "room", label: "Кімната" },
  { key: "ses", label: "Сесія" },
  { key: "dorm", label: "Гуртожиток" },
  { key: "act", label: "Діяльність" },
  { key: "sum", label: "Сума" },
  { key: "sumRank", label: "Ранг за сумою" },
  { key: "score", label: "Показник TOPSIS" },
  { key: "modelRank", label: "Ранг за моделлю AHP+TOPSIS" },
  { key: "positionChange", label: "Зміна позиції" },
  { key: "modelStatus", label: "Статус" },
];

function formatPositionChange(value) {
  if (value === null || value === undefined) return "—";
  if (value > 0) return `+${value}`;
  return String(value);
}

function statusLabel(status) {
  if (status === "retains") return "зберігає місце";
  if (status === "loses") return "втрачає місце";
  return "—";
}

// Таблиця звіту КРОК 4: усі колонки клікабельні для сортування (за
// замовчуванням -- за рангом за моделлю), керується батьком через
// sortKey/sortDir. Рядки тих, хто втрачає місце, підсвічені класом
// "row-loses". Фільтри винесено в окремий блок над таблицею
// (ImportReportFilters.js) -- цей компонент отримує вже відфільтровані
// `rows` і сам фільтрів не знає.
// anonymize -- колонку "Кімната" прибрано (ПІБ уже замінено на "Студент <№>"
// у рядках). onRowClick -- клік по будь-якому рядку відкриває картку
// пояснення студента ("Чому так і що робити", CounterfactualPanel.js).
// Стан сортування колонки для aria-sort (undefined -- колонка не сортована).
function ariaSortFor(key, sortKey, sortDir) {
  if (sortKey !== key) return undefined;
  return sortDir === "desc" ? "descending" : "ascending";
}

// Стрілка біля заголовка відсортованої колонки.
function sortArrowFor(key, sortKey, sortDir) {
  if (sortKey !== key) return "";
  return sortDir === "desc" ? " ▼" : " ▲";
}

const ImportReportTable = ({ rows, sortKey, sortDir, onSort, anonymize = false, onRowClick, selectedId }) => {
  const columns = anonymize ? COLUMNS.filter((col) => col.key !== "room") : COLUMNS;
  return (
    <table className="table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th
              key={col.key}
              className="table-header"
              style={{ cursor: "pointer" }}
              onClick={() => onSort(col.key)}
              aria-sort={ariaSortFor(col.key, sortKey, sortDir)}
            >
              {col.label}
              {sortArrowFor(col.key, sortKey, sortDir)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows.map((row) => (
            <tr
              key={row.id}
              className={row.modelStatus === "loses" ? "row-loses" : undefined}
              style={
                onRowClick
                  ? { cursor: "pointer", outline: selectedId === row.id ? "2px solid var(--text)" : undefined }
                  : undefined
              }
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              title={onRowClick ? "Чому так і що можна зробити" : undefined}
            >
              <td className="table-content">{row.id}</td>
              <td className="table-content">{row.pib || `#${row.id}`}</td>
              {!anonymize && <td className="table-content">{row.room ?? "—"}</td>}
              <td className="table-content">{row.ses ?? "—"}</td>
              <td className="table-content">{row.dorm ?? "—"}</td>
              <td className="table-content">{row.act ?? "—"}</td>
              <td className="table-content">{row.sum ?? "—"}</td>
              <td className="table-content">{row.sumRank ?? "—"}</td>
              <td className="table-content">{formatScore(row.score)}</td>
              <td className="table-content">{row.modelRank ?? "—"}</td>
              <td className="table-content">{formatPositionChange(row.positionChange)}</td>
              <td className="table-content">{statusLabel(row.modelStatus)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td className="table-content" colSpan={columns.length}>
              Немає рядків для відображення.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default ImportReportTable;
